import { useMemo } from 'react';
import { buildPlaceholderTokens, collectFlowVarNames, SYSTEM_VARS } from '../utils/flowVars';

export default function useFlowVars(definition) {
  return useMemo(() => {
    const dynamicNames = collectFlowVarNames(definition);
    const placeholders = buildPlaceholderTokens(definition);

    // System vars first, then user-defined (excluding any name clash).
    const systemOptions = SYSTEM_VARS.map((v) => ({ value: v.key, label: v.label }));
    const systemKeys = new Set(SYSTEM_VARS.map((v) => v.key));
    const dynamicOptions = dynamicNames
      .filter((name) => !systemKeys.has(name))
      .map((name) => ({ value: name, label: name }));

    const varOptions = [...systemOptions, ...dynamicOptions];
    const varNames = varOptions.map((o) => o.value);

    return { varNames, placeholders, varOptions };
  }, [definition]);
}
